import styled from 'styled-components';
import { SkeletonBase } from '../../../UIelements/Skeleton/styles';

export const Card = styled.div`
  box-shadow: 0 0 0.7em ${({ theme }) => theme.colors.boxShadow};
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

export const MainTitle = styled(SkeletonBase)`
  height: 32px;
  width: 50%;
`;

export const SubTitle = styled(SkeletonBase)`
  height: 20px;
  width: 30%;
`;

export const AddressLine = styled(SkeletonBase)<{ width?: string }>`
  height: 16px;
  width: ${({ width }) => width || '90%'};
`;

export const ButtonPlaceholder = styled(SkeletonBase)`
  height: 40px;
  width: 120px;
  border-radius: 8px;
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const MetaColumn = styled.div`
  flex: 1;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MetaTitle = styled(SkeletonBase)`
  height: 14px;
  width: 40%;
`;

export const MetaValue = styled(SkeletonBase)<{ width?: string }>`
  height: 18px;
  width: ${({ width }) => width || '80%'};
`;
